<div class="page-loader">
  <span class="spinner-border text-primary" role="spinner">
  </span>
</div>